import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Transport {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async sendTransaction(transaction) {
        const params = {
            transaction: transaction,
        };
        const res = await this.base.post('/peer/transactions', params);
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=transport.js.map